import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageCmaDemo = lazy(() => {
  return new Promise<{ default: FunctionComponent<{ component?: string }> }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: (props) => <lib.default.MicroSitePage {...props} />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageCmaDemo = (props: { component?: string }) => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageCmaDemo {...props} />
    </Suspense>
  );
};
